import React, { Component, Fragment } from 'react';
import {Link} from 'react-router-dom';
import NotificationSystem from 'react-notification-system';
import PropTypes from 'prop-types';
import {BeatLoader} from 'react-spinners';
import PaymentModule from '../../Misc/PaymentModule'
import{get,putWithHeadersResponse} from '../../../server/actions';
import {currency_symbol, stripeInfo} from '../../../server/constants'
import {convertTwoDecimalPoint, getPaymentGatewayCharges, getLoginParent, _addNotificationError, _addNotification} from '../../../server/util';

class PayBCAC extends Component {
    constructor(props){
        super(props);
        this.state={
            loading:false,
            trxRecId:0,
            schoolId:0,
            payModalObject:{
                studentWiseTransactions:[],
                mealSchoolId:0,
                schoolName:'',
                logoUrl:'',
                transactionType:'',
                transactionDescription:'',
                checkNumb:'',
                isEqualDistSelected:false,
                totalTransactionAmount:0.00,
                balAmount:0.00,
                transactionFees:0.00,
            }
        }
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        let queryString = window.location.search;
        const _payModalObject=this.state.payModalObject
        const refId= decodeURIComponent(queryString.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent('refId').replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
        const schId=decodeURIComponent(queryString.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent('schId').replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
        sessionStorage.removeItem('bcacUrl');
        _payModalObject.mealSchoolId=schId;
        _payModalObject.transactionType="Deposit";
        _payModalObject.paymentType="Online",
        _payModalObject.appFeeAmount=stripeInfo(schId).application_free,
        this.setState({trxRecId:refId, schoolId:schId, payModalObject:_payModalObject},()=>{
            this.getPaymentDetails();
        });        
    }
    getPaymentDetails=()=>{
        this.setState({loading: true});
       const url=`/reports/pkgTrxInfo/${this.state.trxRecId}?access_token=`;
       get(url)
       .then((response) => {
           if (!response.ok) {
               throw Error(response.statusText);
           }
           return response.json();
       }).then(data => {
           let totAmt=0.00
           const list=((data||{}).response||[]).map((item=>{
               totAmt=totAmt+parseFloat(convertTwoDecimalPoint(item.pkgCost,2))
               return {...item, fullName:item.stdLName+', '+item.stdFName}
           }));
           const _payModalObject=this.state.payModalObject||{};
           _payModalObject.trxRecId=this.state.trxRecId;
           _payModalObject.studentWiseTransactions=list;
           _payModalObject.balAmount=totAmt;
           _payModalObject.transactionFees=(getPaymentGatewayCharges(this.state.schoolId,totAmt,false))
           this.setState({ payModalObject:_payModalObject, loading: false })
       })
       .catch(
           (error) => {
               console.log('Get orderlist response', error)
               const _payModalObject=this.state.payModalObject||{};
               _payModalObject.studentWiseTransactions=[];
               this.setState({ payModalObject:_payModalObject, loading: false}) }
       )
   }
   computAmount(){
       let _computeAmount=0.0;
        (this.state.payModalObject.studentWiseTransactions||[]).map((s)=>{
            _computeAmount=_computeAmount+ parseFloat(convertTwoDecimalPoint(s.pkgCost));
        });
        return isNaN(_computeAmount)?0.00:_computeAmount;
    }
    onSubmitPayment=(reqObj)=>{
        this.setState({loading:true});
        let headers = {
            'Content-Type': 'application/json'
        };
        putWithHeadersResponse("/transactions/pkgPayment/"+this.state.trxRecId+"?access_token=", JSON.stringify(reqObj),headers)
        .then((response) => {
          if (response.status === 200) {                 
              this.onPaymentDone(response);
          } else if (!response.ok) {
            this.onPaymentDone(response);
              throw Error(response);
          }
          this.setState({loading:false});
      }).catch(
          (error) => {        
            this.setState({loading:false});       
            console.log('Payment error:',error);
          }
      );
    }
    onPaymentDone=(resp)=>{
        if(resp.status==200){           
            _addNotification('added payment successfully.', this); 
            setTimeout(() =>            
            //this.props.history.push('/parent')
            window.location.replace('/parent')
                , 3000);
          }else{
            _addNotificationError('Failed to add payment ! Try again.', this);
          }
    }
    render() {
        const totalCost=this.computAmount();
        const charges=(getPaymentGatewayCharges(this.state.schoolId,totalCost,true));
       
        return (
        <Fragment>
        <section className="full-width clearfix" style={{marginTop:'20px'}}>
            <NotificationSystem ref="notificationSystem"/>
            <div className="container parent-container" style={{minHeight:445}}>
                <div className="modal-header row">
                    <h4 className="modal-title modal-title-color col-md-6" id="deleteLabel">Add Payments</h4>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-12">
                                        <table className="table table-payment-modal">
                                            <thead>
                                                <tr>
                                                    <td>Name</td>
                                                    <td style={{width:'400px',textAlign:'right', paddingRight:'150px'}}>Amount</td>
                                                </tr>
                                            </thead>
                                            <tbody style={{maxHeight:'300px',overflowY:'auto',display:'block'}}>
                                            {
                                                this.state.payModalObject.studentWiseTransactions.map((row,key)=>{
                                                    return (<tr>
                                                        <td>{row.fullName}</td>
                                                        <td style={{width:'400px',textAlign:'right', paddingRight:'150px'}}>{currency_symbol(this.state.schoolId)+' '+convertTwoDecimalPoint(row.pkgCost)}</td>
                                                    </tr>)
                                                    })
                                            }                                                
                                            </tbody>
                                            <tfoot style={{backgroundColor:'#f5f2f2'}}>
                                                <tr>
                                                    <td>Transaction charges</td>
                                                    <td style={{width:'400px',textAlign:'right', paddingRight:'150px'}}>{currency_symbol(this.state.schoolId)+' '+convertTwoDecimalPoint(charges)}</td>
                                                </tr>                                                
                                                <tr>
                                                    <td>Total Amount :</td>
                                                    <td style={{width:'400px',textAlign:'right', paddingRight:'150px'}}>{currency_symbol(this.state.schoolId)+' '+convertTwoDecimalPoint(totalCost+charges)}</td></tr>
                                            </tfoot>
                                        </table>
                                    </div>                                        
                                </div>
                                <div className="text-right">
                                    <div className="row">
                                        <div className="col-md-2 pull-right">
                                        {
                                        (totalCost+charges)>0?
                                        <PaymentModule paymentDesc={"BCAC_PAY"}
                                            schoolId={this.state.schoolId}
                                                    userInfo={{
                                                        parent:getLoginParent()
                                                        }}
                                                    paymentObj={this.state.payModalObject} 
                                                    onToken={(token)=>{
                                                       const req= {
                                                            "mealSchool": {
                                                              "schoolId": this.state.payModalObject.mealSchoolId
                                                            },
                                                            "paymentType": "Online",
                                                            "totalPaidAmt":this.state.payModalObject.balAmount,
                                                            "appFeeAmount": stripeInfo(this.state.payModalObject.mealSchoolId).application_free,
                                                            "transactionFees": this.state.payModalObject.transactionFees
                                                          }
                                                          if(typeof(token)==='string'){
                                                            req["transactionToken"]=token;
                                                        }
                                                        else{
                                                            req["transferId"]=token.transferId;
                                                            req["chargeId"]=token.chargeId;
                                                        }
                                                        this.onSubmitPayment(req);
                                                        
                                                    }}
                                                    //onPaymentDone={this.onPaymentDone} 
                                                    showHideLoading={this.showHideLoading}
                                                    onValidationError={(error)=>{
                                                        _addNotificationError(error,this);
                                                    }}
                                                     />
                                        :null}
                                        {/* <button type="button" id="paySubmit" onClick={(e)=>{
                                           // this.onSubmitPayment(e);
                                            }} className="btn btn-success">
                                            <i className="fa fa-check-circle" style={{ margin: '0 0 0 5px' }}></i> Pay
                                            </button> */}

                                    
                                        </div>
                                        <div className="col-md-2 pull-right">
                                            <button type="button" className="btn btn-danger"
                                            onClick={() => this.props.history.push('/parent')}>
                                                <i className="fa fa-times-circle" style={{ margin: '0 0 0 5px' }}></i> Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>    
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </Fragment>
        );
    }
}
PayBCAC.contextTypes = {
    router: PropTypes.object.isRequired
}
export default PayBCAC;


// WEBPACK FOOTER //
// ./src/components/Parent/bcac/payBCAC.jsx